export const translations = {
  en: {
    // SEO
    seo: {
      title: 'Saham Holding | Leading Technology Solutions & Digital Transformation',
      description: 'Saham Holding is Saudi Arabia\'s premier technology enterprise and digital transformation partner. We specialize in Enterprise AI, Virtual Reality (VR), Cloud Computing, and Cyber Security. Empowering businesses with 15+ years of premium technological expertise in Riyadh and across the Middle East.',
      keywords: 'Saham Holding, Saham Systems, Saham Saudi Arabia, Technology Solutions, Digital Transformation, AI Saudi, Artificial Intelligence Riyadh, Cloud Computing KSA, VR Solutions Saudi, Virtual Reality Development, Software Development Riyadh, IT Consulting Saudi Arabia, Cybersecurity Riyadh, Enterprise Technology, Holding Company Riyadh, Vision 2030 Saudi',
    },
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      sectors: 'Sectors',
      services: 'Services',
      subsidiaries: 'Subsidiaries',
      portfolio: 'Portfolio',
      contact: 'Contact',
      brand: 'Saham Holding',
    },

    // Hero Section
    hero: {
      title: 'Leading Technology Solutions for the Future',
      subtitle: 'Empowering businesses with innovative digital solutions and cutting-edge technology',
      cta: 'Get Started',
      learnMore: 'Learn More',
      badge: 'Leading Technology Solutions',
      scrollText: 'Scroll to explore',
    },

    // About Section
    about: {
      title: 'About Saham Holding',
      subtitle: 'Your Trusted Technology Partner',
      badge: 'About Us',
      description: 'Saham Holding is a leading technology company that specializes in providing innovative digital solutions to businesses worldwide. With years of experience and a team of experts, we help organizations transform their digital presence and achieve their goals.',
      stats: {
        clients: '500+',
        projects: '1000+',
        years: '15+',
        team: '50+',
      },
      statsLabels: {
        clients: 'Happy Clients',
        projects: 'Projects Completed',
        years: 'Years Experience',
        team: 'Team Members',
      },
      features: [
        'Innovative Technology Solutions',
        'Expert Team of Professionals',
        'Proven Track Record',
        'Customer-Centric Approach',
        '24/7 Support'
      ],
      innovation: 'Innovation at Core',
      innovationDesc: 'We believe in pushing boundaries and creating solutions that make a difference in the digital world.',
    },

    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive Technology Solutions',
      badge: 'Our Expertise',
      learnMore: 'Learn More',
      cta: 'Get Started',
      web: {
        title: 'Web Development',
        description: 'Custom web applications and modern websites built with cutting-edge technologies',
        features: [
          'React & Next.js',
          'Node.js & Express',
          'MongoDB & PostgreSQL',
          'AWS & Vercel',
        ],
      },
      mobile: {
        title: 'Mobile Development',
        description: 'Native and cross-platform mobile applications for iOS and Android platforms',
        features: [
          'React Native',
          'Flutter',
          'iOS & Android',
          'App Store & Play Store',
        ],
      },
      cloud: {
        title: 'Cloud Solutions',
        description: 'Scalable cloud infrastructure, migration services, and cloud consulting',
        features: [
          'AWS & Azure',
          'Docker & Kubernetes',
          'CI/CD Pipelines',
          'Serverless Architecture',
        ],
      },
      security: {
        title: 'Cybersecurity',
        description: 'Comprehensive security solutions to protect your business and infrastructure',
        features: [
          'Penetration Testing',
          'Security Audits',
          'Compliance & GDPR',
          '24/7 Monitoring',
        ],
      },
      ai: {
        title: 'AI & Machine Learning',
        description: 'Intelligent solutions powered by artificial intelligence and machine learning',
        features: [
          'Machine Learning',
          'Computer Vision',
          'NLP & Chatbots',
          'Predictive Analytics',
        ],
      },
      vr: {
        title: 'Virtual Reality (VR) Solutions',
        description: 'Immersive VR experiences for training, education, and entertainment.',
        features: [
          '360° Virtual Tours',
          'VR Training Simulations',
          'Interactive VR Education',
          'Custom VR Applications',
        ],
      },
      additionalFeatures: {
        support: {
          title: '24/7 Support',
          description: 'Round-the-clock technical support and maintenance',
        },
        scalable: {
          title: 'Scalable Solutions',
          description: 'Flexible solutions that grow with your business',
        },
        security: {
          title: 'Security First',
          description: 'Enterprise-grade security for your peace of mind',
        },
      },
    },



    // Subsidiaries Section
    subsidiaries: {
      title: 'Our Subsidiaries',
      subtitle: 'A diverse portfolio of specialized companies driving innovation across industries',
      badge: 'Our Companies',
      learnMore: 'Learn More',
      cta: 'Explore All Companies',
      stats: {
        subsidiaries: 'Subsidiaries',
        employees: 'Total Employees',
        years: 'Years Combined',
        success: 'Success Rate',
      },
      tareen: {
        name: 'Tareen App',
        description: 'The Tareen Medical Offers app provides clients and centers with communication and booking portals using innovative, technological method.',
        industry: 'Healthcare Technology',
        focus: 'Medical Booking & Communication',
      },
      endak: {
        name: 'Endak App',
        description: 'Endak App, the leading company in providing smart delivery services through an advanced technology platform.',
        industry: 'Smart Delivery',
        focus: 'Smart Delivery Services',
      },
      pl: {
        name: 'PL',
        description: 'Digital manufacturing and artificial intelligence solutions for modern business needs.',
        industry: 'Digital Manufacturing & AI',
        focus: 'Digital Manufacturing & AI Solutions',
      },
      moraAi: {
        name: 'Mora AI',
        description: 'An advanced AI company delivering intelligent solutions in medical diagnosis, education, finance, and legal sectors.',
        industry: 'Artificial Intelligence',
        focus: 'AI Solutions Across Sectors',
      },
      antyeek: {
        name: 'Antyeek App',
        description: 'The antyeek app provides the easiest and best way to follow up and book appointments at men\'s salons and centers.',
        industry: 'Beauty & Wellness',
        focus: 'Salon Booking & Management',
      },
    },

    // Portfolio Section
    portfolio: {
      title: 'Our Portfolio',
      subtitle: 'Showcasing Our Best Work',
      projects: [
        {
          title: 'E-Commerce Platform',
          category: 'Web Development',
          description: 'A modern e-commerce platform with advanced features',
        },
        {
          title: 'Banking App',
          category: 'Mobile Development',
          description: 'Secure mobile banking application for financial services',
        },
        {
          title: 'AI Analytics Dashboard',
          category: 'AI & ML',
          description: 'Intelligent analytics platform with predictive insights',
        },
      ],
    },

    // Contact Section
    contact: {
      title: 'Get In Touch',
      subtitle: 'Let\'s Discuss Your Project',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        message: 'Your Message',
        send: 'Send Message',
      },
      info: {
        address: 'Khobar, Saudi Arabia',
        phone: '+966-533040509',
        email: 'info@saham-holding.com',
        addressLabel: 'Address',
        phoneLabel: 'Phone',
        emailLabel: 'Email',
      },
      viewMap: 'View on Map',
      readyToStart: 'Ready to Start?',
      scheduleCall: 'Schedule a Call',
      scheduleDescription: 'Let\'s discuss your next project and bring your ideas to life.',
      ourLocation: 'Our Location',
    },

    // Footer
    footer: {
      description: 'Leading technology solutions for the future',
      tagline: 'Future Technology',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      madeWith: 'Made with',
      bySaham: 'by Saham Holding',
      links: {
        about: 'About Us',
        services: 'Services',
        portfolio: 'Portfolio',
        contact: 'Contact',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
      },
      copyright: '© 2026 Saham Holding. All rights reserved.',
    },

    // Sectors Section
    sectors: {
      title: 'Our Sectors',
      subtitle: 'We serve a wide range of industries with innovative digital solutions.',
      badge: 'Industries',
      learnMore: 'Learn More',
      cta: 'Explore All Sectors',
      stats: {
        sectors: 'Sectors',
        projects: 'Projects',
        clients: 'Clients',
        years: 'Years Experience',
      },
      financial: {
        title: 'Financial Services',
        description: 'Digital banking, investment, and payment solutions for the financial sector.',
        features: [
          'Secure Banking Solutions',
          'Investment Platforms',
          'Payment Systems',
          'Fraud Detection',
          'Risk Management',
          'Regulatory Compliance',
        ],
        stats: '100+ Financial Projects',
      },
      oilGas: {
        title: 'Oil & Gas',
        description: 'Technology for production optimization, safety, and supply chain in energy.',
        features: [
          'Production Optimization',
          'Safety Monitoring',
          'Supply Chain Management',
          'IoT Implementation',
          'Advanced Analytics',
          'Environmental Impact',
        ],
        stats: '50+ Energy Projects',
      },
      government: {
        title: 'Government',
        description: 'Digital transformation and citizen engagement for government entities.',
        features: [
          'Digital Services',
          'Citizen Engagement',
          'Internal Processes',
          'Data Protection',
          'Transparent Governance',
          'Administrative Efficiency',
        ],
        stats: '75+ Government Projects',
      },
      healthcare: {
        title: 'Healthcare',
        description: 'AI-powered diagnostics, patient management, and telemedicine platforms.',
        features: [
          'Medical Diagnostics',
          'Patient Management',
          'Telemedicine Platforms',
          'Health Records',
          'AI-Powered Care',
          'Clinical Analytics',
        ],
        stats: '60+ Healthcare Projects',
      },
      education: {
        title: 'Education',
        description: 'E-learning, virtual classrooms, and analytics for educational institutions.',
        features: [
          'Learning Management',
          'Virtual Classrooms',
          'Student Analytics',
          'Interactive Content',
          'Assessment Tools',
          'Educational AI',
        ],
        stats: '40+ Education Projects',
      },
      technology: {
        title: 'Technology',
        description: 'Software, cloud, cybersecurity, and innovation for tech-driven businesses.',
        features: [
          'Software Development',
          'Cloud Solutions',
          'Cybersecurity',
          'AI & Machine Learning',
          'Digital Transformation',
          'Innovation Labs',
        ],
        stats: '200+ Tech Projects',
      },
    },
    privacy: {
      title: 'Privacy Policy',
      intro: 'Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.',
      infoTitle: 'Information We Collect',
      info1: 'Personal identification information (Name, email address, phone number, etc.)',
      info2: 'Usage data and cookies',
      useTitle: 'How We Use Your Information',
      use1: 'To provide and maintain our service',
      use2: 'To improve our website',
      use3: 'To communicate with you',
      contactTitle: 'Contact Us',
      contactText: 'If you have any questions about this Privacy Policy, please contact us at info@saham-holding.com.',
    },
    terms: {
      title: 'Terms of Service',
      intro: 'By accessing or using our website, you agree to be bound by these Terms of Service. Please read them carefully.',
      useTitle: 'Use of Site',
      use1: 'You must be at least 18 years old to use this site.',
      use2: 'You agree not to misuse the site or its content.',
      ipTitle: 'Intellectual Property',
      ip1: 'All content on this site is the property of Saham Holding or its licensors.',
      ip2: 'You may not reproduce, distribute, or create derivative works without permission.',
      contactTitle: 'Contact Us',
      contactText: 'If you have any questions about these Terms, please contact us at info@saham-holding.com.',
    },
  },

  ar: {
    // SEO
    seo: {
      title: 'سهم الأنظمة القابضة | حلول تقنية رائدة وتحول رقمي',
      description: 'شركة سهم الأنظمة القابضة هي الشريك التقني الرائد في المملكة العربية السعودية لخدمات التحول الرقمي المتكامل. متخصصون في الذكاء الاصطناعي، الواقع الافتراضي، حلول الحوسبة السحابية والأمن السيبراني في الرياض وكافة دول الخليج مع خبرة تفوق 15 عاماً من الريادة التكنولوجية.',
      keywords: 'سهم القابضة, شركة سهم للأنظمة, سهم الأنظمة القابضة, شركة تقنية بالرياض, تحول رقمي السعودية, حلول الذكاء الاصطناعي, واقع افتراضي الرياض, حوسبة سحابية السعودية, تطوير برمجيات الرياض, استشارات تقنية السعودية, شركة تقنية الرياض, الأمن السيبراني السعودية, شركة قابضة الرياض, شركات التكنولوجيا السعودية, رؤية 2030 تقنية, شركة حلول تكنولوجية الرياض',
    },
    // Navigation
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      sectors: 'قطاعتنا',
      services: 'خدماتنا',
      subsidiaries: 'الشركات التابعة',
      portfolio: 'أعمالنا',
      contact: 'اتصل بنا',
      brand: 'سهم الانظمة القابضة',
    },

    // Hero Section
    hero: {
      title: 'حلول تقنية رائدة للمستقبل',
      subtitle: 'تمكين الشركات بحلول رقمية مبتكرة وتقنيات متطورة',
      cta: 'ابدأ الآن',
      learnMore: 'اعرف المزيد',
      badge: 'حلول تقنية رائدة',
      scrollText: 'تمرير للإستكشار',
    },

    // About Section
    about: {
      title: 'حول سهم القابضة',
      subtitle: 'شريكك التكنولوجي الموثوق',
      badge: 'من نحن',
      description: 'سهم القابضة هي شركة تكنولوجيا رائدة متخصصة في تقديم حلول رقمية مبتكرة للشركات في جميع أنحاء العالم. مع سنوات من الخبرة وفريق من الخبراء، نساعد المؤسسات على تحويل وجودها الرقمي وتحقيق أهدافها.',
      stats: {
        clients: '500+',
        projects: '1000+',
        years: '15+',
        team: '50+',
      },
      statsLabels: {
        clients: 'عميل سعيد',
        projects: 'مشروع مكتمل',
        years: 'سنوات خبرة',
        team: 'عضو فريق',
      },
      features: [
        'حلول تقنية مبتكرة',
        'فريق من الخبراء المحترفين',
        'سجل حافل بالإنجازات',
        'نهج يركز على العميل',
        'دعم فني على مدار الساعة'
      ],
      innovation: 'الابتكار في جوهرنا',
      innovationDesc: 'نؤمن بتجاوز الحدود وابتكار حلول تصنع فرقاً في العالم الرقمي.',
    },

    // Services Section
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول تقنية شاملة ومتطورة',
      badge: 'خبرتنا',
      learnMore: 'اعرف المزيد',
      cta: 'ابدأ الآن',
      web: {
        title: 'تطوير المواقع الإلكترونية',
        description: 'تصميم وتطوير مواقع وتطبيقات ويب احترافية بأحدث التقنيات',
        features: [
          'ريأكت ونيكست جي إس',
          'نود جي إس وإكسبريس',
          'مونغو دي بي وبوستجري إس كيو إل',
          'خدمات AWS وفيرسل',
        ],
      },
      mobile: {
        title: 'تطوير تطبيقات الجوال',
        description: 'تطبيقات جوال أصلية ومتعددة المنصات لنظامي iOS وAndroid',
        features: [
          'ريأكت نيتيف',
          'فلاتر',
          'iOS و Android',
          'متجر التطبيقات وGoogle Play',
        ],
      },
      cloud: {
        title: 'حلول الحوسبة السحابية',
        description: 'بنية تحتية سحابية قابلة للتطوير وخدمات الهجرة والاستضافة',
        features: [
          'خدمات AWS وAzure',
          'دوكر وكوبرنيتس',
          'CI/CD بايبلاينز',
          'بنية بدون خوادم',
        ],
      },
      security: {
        title: 'الأمن السيبراني',
        description: 'حلول أمنية شاملة ومتطورة لحماية بياناتك وبنيتك التحتية',
        features: [
          'اختبار الاختراق',
          'تدقيقات الأمان',
          'الامتثال وGDPR',
          'مراقبة على مدار الساعة',
        ],
      },
      ai: {
        title: 'الذكاء الاصطناعي والتعلم الآلي',
        description: 'حلول ذكية متقدمة مدعومة بالذكاء الاصطناعي والتعلم الآلي',
        features: [
          'تعلم الآلة',
          'رؤية الحاسوب',
          'معالجة اللغة الطبيعية والدردشة الآلية',
          'تحليلات تنبؤية',
        ],
      },
      vr: {
        title: 'حلول الواقع الافتراضي (VR)',
        description: 'تجارب واقع افتراضي غامرة للتدريب والتعليم والترفيه.',
        features: [
          'جولات افتراضية 360 درجة',
          'محاكاة التدريب بالواقع الافتراضي',
          'التعليم التفاعلي بالواقع الافتراضي',
          'تطبيقات واقع افتراضي مخصصة',
        ],
      },
      additionalFeatures: {
        support: {
          title: 'دعم على مدار الساعة',
          description: 'دعم فني وصيانة على مدار الساعة',
        },
        scalable: {
          title: 'حلول قابلة للتطوير',
          description: 'حلول مرنة تنمو مع أعمالك',
        },
        security: {
          title: 'الأمان أولاً',
          description: 'أمان على مستوى المؤسسات لراحة بالك',
        },
      },
    },



    // Subsidiaries Section
    subsidiaries: {
      title: 'شركاتنا التابعة',
      subtitle: 'مجموعة متنوعة من الشركات المتخصصة التي تحرك الابتكار عبر الصناعات',
      badge: 'شركاتنا',
      learnMore: 'اعرف المزيد',
      cta: 'استكشار جميع الشركات',
      stats: {
        subsidiaries: 'شركات تابعة',
        employees: 'إجمالي عدد الموظفين',
        years: 'سنوات خبرة',
        success: 'معدل النجاح',
      },
      tareen: {
        name: 'Tareen App',
        description: 'يقدم تطبيق ترين الطبي بوابات تواصل وحجز مبتكرة للعملاء والمراكز باستخدام أحدث التقنيات.',
        industry: 'تقنية الرعاية الصحية',
        focus: 'حجز طبي وتواصل',
      },
      endak: {
        name: 'Endak App',
        description: 'تطبيق عندك هو الشركة الرائدة في تقديم خدمات التوصيل الذكي عبر منصة تقنية متقدمة.',
        industry: 'التوصيل الذكي',
        focus: 'خدمات التوصيل الذكي',
      },
      pl: {
        name: 'PL',
        description: 'حلول التصنيع الرقمي والذكاء الاصطناعي لتلبية احتياجات الأعمال الحديثة.',
        industry: 'التصنيع الرقمي والذكاء الاصطناعي',
        focus: 'حلول التصنيع الرقمي والذكاء الاصطناعي',
      },
      moraAi: {
        name: 'Mora AI',
        description: 'شركة ذكاء اصطناعي متقدمة تقدم حلولاً ذكية في التشخيص الطبي، التعليم، المالية، والقطاعات القانونية.',
        industry: 'الذكاء الاصطناعي',
        focus: 'حلول الذكاء الاصطناعي عبر القطاعات',
      },
      antyeek: {
        name: 'Antyeek App',
        description: 'يوفر تطبيق أنتيك أسهل وأفضل طريقة لمتابعة وحجز المواعيد في صالونات ومراكز الرجال.',
        industry: 'الجمال والعناية',
        focus: 'حجز وإدارة الصالونات',
      },
    },

    // Portfolio Section
    portfolio: {
      title: 'أعمالنا',
      subtitle: 'عرض أفضل أعمالنا',
      projects: [
        {
          title: 'منصة التجارة الإلكترونية',
          category: 'تطوير الويب',
          description: 'منصة تجارة إلكترونية حديثة بميزات متقدمة',
        },
        {
          title: 'تطبيق البنوك',
          category: 'تطوير الجوال',
          description: 'تطبيق بنكي جوال آمن للخدمات المالية',
        },
        {
          title: 'لوحة تحكم الذكاء الاصطناعي',
          category: 'الذكاء الاصطناعي',
          description: 'منصة تحليلات ذكية مع رؤى تنبؤية',
        },
      ],
    },

    // Contact Section
    contact: {
      title: 'تواصل معنا',
      subtitle: 'دعنا نناقش مشروعك',
      form: {
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        message: 'رسالتك',
        send: 'إرسال الرسالة',
      },
      info: {
        address: 'الخبر، المملكة العربية السعودية',
        phone: '+966-533040509',
        email: 'info@saham-holding.com',
        addressLabel: 'العنوان',
        phoneLabel: 'رقم الهاتف',
        emailLabel: 'الايميل',
      },
      viewMap: 'عرض على الخريطة',
      readyToStart: 'جاهز للبدء؟',
      scheduleCall: 'احجز مكالمة',
      scheduleDescription: 'دعنا نناقش مشروعك التالي ونجعل أفكارك تحقق.',
      ourLocation: 'موقعنا',
    },

    // Footer
    footer: {
      description: 'حلول تقنية رائدة للمستقبل',
      tagline: 'حلول تقنية رائدة',
      quickLinks: 'روابط سريعة',
      legal: 'قانوني',
      madeWith: 'مصنوع من',
      bySaham: 'بواسطة سهم الانظمة القابضة',
      links: {
        about: 'من نحن',
        services: 'خدماتنا',
        portfolio: 'أعمالنا',
        contact: 'اتصل بنا',
        privacy: 'سياسة الخصوصية',
        terms: 'شروط الخدمة',
      },
      copyright: '© 2026 سهم الانظمة القابضة. جميع الحقوق محفوظة.',
    },

    // Sectors Section
    sectors: {
      title: 'قطاعاتنا',
      subtitle: 'نخدم مجموعة واسعة من الصناعات بحلول رقمية مبتكرة.',
      badge: 'الصناعات',
      learnMore: 'اعرف المزيد',
      cta: 'استكشاف جميع القطاعات',
      stats: {
        sectors: 'القطاعات',
        projects: 'المشاريع',
        clients: 'العملاء',
        years: 'سنوات الخبرة',
      },
      financial: {
        title: 'الخدمات المالية',
        description: 'الخدمات المصرفية الرقمية، الاستثمار، وحلول الدفع للقطاع المالي.',
        features: [
          'حلول مصرفية آمنة',
          'منصات استثمارية',
          'أنظمة دفع إلكترونية',
          'كشف الاحتيال',
          'إدارة المخاطر',
          'الامتثال التنظيمي',
        ],
        stats: '+100 مشروع مالي',
      },
      oilGas: {
        title: 'النفط والغاز',
        description: 'تقنيات لتحسين الإنتاج، السلامة، وسلسلة التوريد في قطاع الطاقة.',
        features: [
          'تحسين الإنتاج',
          'مراقبة السلامة',
          'إدارة سلسلة التوريد',
          'تطبيقات إنترنت الأشياء',
          'تحليلات متقدمة',
          'الأثر البيئي',
        ],
        stats: '+50 مشروع طاقة',
      },
      government: {
        title: 'الحكومة',
        description: 'التحول الرقمي وتعزيز تفاعل المواطنين للجهات الحكومية.',
        features: [
          'خدمات رقمية',
          'تفاعل المواطنين',
          'عمليات داخلية',
          'حماية البيانات',
          'حوكمة شفافة',
          'كفاءة إدارية',
        ],
        stats: '+75 مشروع حكومي',
      },
      healthcare: {
        title: 'الرعاية الصحية',
        description: 'تشخيصات مدعومة بالذكاء الاصطناعي، إدارة المرضى، ومنصات الطب عن بعد.',
        features: [
          'تشخيصات طبية',
          'إدارة المرضى',
          'منصات الطب عن بعد',
          'سجلات صحية',
          'رعاية مدعومة بالذكاء الاصطناعي',
          'تحليلات سريرية',
        ],
        stats: '60+ Healthcare Projects',
      },
      education: {
        title: 'التعليم',
        description: 'التعليم الإلكتروني، الفصول الافتراضية، والتحليلات للمؤسسات التعليمية.',
        features: [
          'إدارة التعلم',
          'فصول افتراضية',
          'تحليلات الطلاب',
          'محتوى تفاعلي',
          'أدوات التقييم',
          'ذكاء تعليمي',
        ],
        stats: '40+ Education Projects',
      },
      technology: {
        title: 'التقنية',
        description: 'تطوير البرمجيات، الحوسبة السحابية، الأمن السيبراني، والابتكار للأعمال التقنية.',
        features: [
          'تطوير البرمجيات',
          'حلول سحابية',
          'الأمن السيبراني',
          'الذكاء الاصطناعي والتعلم الآلي',
          'التحول الرقمي',
          'مختبرات الابتكار',
        ],
        stats: '200+ Tech Projects',
      },
    },
    privacy: {
      title: 'سياسة الخصوصية',
      intro: 'خصوصيتك مهمة بالنسبة لنا. توضح سياسة الخصوصية هذه كيف نقوم بجمع واستخدام والكشف عن وحماية معلوماتك عند زيارتك لموقعنا.',
      infoTitle: 'المعلومات التي نجمعها',
      info1: 'معلومات التعريف الشخصية (الاسم، البريد الإلكتروني، رقم الهاتف، إلخ)',
      info2: 'بيانات الاستخدام وملفات تعريف الارتباط',
      useTitle: 'كيف نستخدم معلوماتك',
      use1: 'لتقديم خدماتنا وصيانتها',
      use2: 'لتحسين موقعنا',
      use3: 'للتواصل معك',
      contactTitle: 'اتصل بنا',
      contactText: 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا عبر info@saham-holding.com.',
    },
    terms: {
      title: 'شروط الخدمة',
      intro: 'من خلال الوصول إلى موقعنا أو استخدامه، فإنك توافق على الالتزام بهذه الشروط. يرجى قراءتها بعناية.',
      useTitle: 'استخدام الموقع',
      use1: 'يجب أن يكون عمرك 18 عامًا على الأقل لاستخدام هذا الموقع.',
      use2: 'توافق على عدم إساءة استخدام الموقع أو محتواه.',
      ipTitle: 'الملكية الفكرية',
      ip1: 'جميع المحتويات على هذا الموقع هي ملك لسهم القابضة أو الجهات المرخصة لها.',
      ip2: 'لا يجوز لك إعادة إنتاج أو توزيع أو إنشاء أعمال مشتقة بدون إذن.',
      contactTitle: 'اتصل بنا',
      contactText: 'إذا كان لديك أي أسئلة حول هذه الشروط، يرجى التواصل معنا عبر info@saham-holding.com.',
    },
  },
}; 